import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'json-schema-example-page',
    templateUrl: './json-schema-example-page.component.html',
    styleUrls: ['./json-schema-example-page.component.scss'],
    host: {
        class: 'dock-y'
    },
    standalone: false
})
export class JsonSchemaExamplePageComponent implements OnInit {

  ngOnInit(): void {}
}

